module.exports = __webpack_public_path__ + "static/media/Barmag 1c.1950e4b7.jpg";